const fetchGroupSetReducer = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        error: undefined,
        groupsLoaded: false,
      };
    case 'success':
      return {
        ...state,
        error: undefined,
        groupsLoaded: true,
      };
    case 'error':
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default fetchGroupSetReducer;
